export const NUMBER_CELL = 'numberCell';
export const DATE_CELL = 'dateCell';
export const GEO_POINT_CELL = 'GeoPoint';
export const DRILL_DOWN_CELL = 'drillDownCell';
export const ENTITY_CELL = 'entityCell';
export const BONUS_STATUS_CELL = 'bonusStatusCell';
export const BONUS_REWARD_CELL = 'bonusRewardCell';
export const BONUS_EXPECTATION_CELL = 'bonusExpectationCell';
export const BONUS_QUALIFIED_CELL = 'bonusQualifiedCell';
export const BOOLEAN_ICON_CELL = 'booleanIconCell';
export const BONUS_SCORE_CELL = 'bonusScoreCell';
export const COLOUR_CODED_NUMBER_CELL = 'colourCodedNumberCell';
